import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer data-testid="site-footer" className="bg-midnight border-t border-paper/10 pt-24 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <p className="font-serif font-light text-[11vw] sm:text-[7vw] lg:text-[5vw] leading-none tracking-tight text-paper/90 whitespace-nowrap overflow-hidden">
          Gurova<span className="text-brass">-</span>Vacher
        </p>
        <div className="mt-16 grid md:grid-cols-3 gap-12 border-t border-paper/10 pt-12">
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-brasslight mb-5">{t("footer.contact")}</p>
            <div className="space-y-2 text-sm text-paper/60">
              <p>+33 (0)6 07 27 84 28</p>
              <p>olena.gurova@gmail.com</p>
              <p className="leading-relaxed">3 rue Lefort Gonssolin<br />76130 Mont-Saint-Aignan</p>
            </div>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-brasslight mb-5">{t("footer.expertise")}</p>
            <div className="space-y-2 text-sm text-paper/60">
              {t("footer.expertiseLines").map((l) => <p key={l}>{l}</p>)}
            </div>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-brasslight mb-5">{t("footer.infos")}</p>
            <div className="space-y-2 text-sm text-paper/60">
              <p>SIRET 523 682 490 00017</p>
              <Link data-testid="footer-legal-link" to="/mentions-legales" className="block hover:text-brasslight transition-colors duration-300">{t("footer.legal")}</Link>
              <Link data-testid="footer-admin-link" to="/admin" className="block hover:text-brasslight transition-colors duration-300">{t("footer.admin")}</Link>
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-col sm:flex-row justify-between gap-3 text-xs text-paper/35 border-t border-paper/10 pt-8">
          <p>© {new Date().getFullYear()} Oléna Gurova-Vacher. {t("footer.rights")}</p>
          <p>Traduction · Translation · Перевод · Переклад</p>
        </div>
      </div>
    </footer>
  );
}
